import { render } from "./SelectGroupModal.vue?vue&type=template&id=09090d06&scoped=true"
import script from "./SelectGroupModal.vue?vue&type=script&lang=js"
export * from "./SelectGroupModal.vue?vue&type=script&lang=js"

import "./SelectGroupModal.vue?vue&type=style&index=0&id=09090d06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09090d06"]])

export default __exports__